import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const MessageTemplateIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M16.2067 9.20691V7.79344H7.79327V9.20691H16.2067ZM16.2067 11.3103V9.89681H7.79327V11.3103H16.2067ZM16.2067 13.4136V12.0002H7.79327V13.4136H16.2067ZM17.6202 5.00017C18.0016 5.00017 18.3269 5.13479 18.5962 5.40402C18.8654 5.67325 19 5.99857 19 6.37998V14.7934C19 15.1749 18.8654 15.5058 18.5962 15.7862C18.3269 16.0667 18.0016 16.2069 17.6202 16.2069H7.79327L5 19.0002V6.37998C5 5.99857 5.13462 5.67325 5.40385 5.40402C5.5303 5.27359 5.68214 5.17047 5.85 5.10101C6.01786 5.03155 6.19817 4.99723 6.37981 5.00017H17.6202Z'
                fill='currentColor'
            />
        </>
    ),
})

MessageTemplateIcon.displayName = 'MessageTemplateIcon'
